import { useEffect, useRef, useState } from 'react'
import { FilterDropdown } from '../../components/UI.jsx'
import { COMMERCIAL_PERIODS } from './commercialPeriods.js'

export default function CommercialPeriodFilter({ preset, period, detail, onPreset, onCustom }) {
  const [open, setOpen] = useState(false)
  const [draft, setDraft] = useState(period)
  const root = useRef(null)
  const firstInput = useRef(null)
  useEffect(() => {
    if (!open) return
    firstInput.current?.focus()
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false) }
    const escape = event => { if (event.key === 'Escape') setOpen(false) }
    document.addEventListener('pointerdown', outside)
    document.addEventListener('keydown', escape)
    return () => { document.removeEventListener('pointerdown', outside); document.removeEventListener('keydown', escape) }
  }, [open])
  const invalid = !draft.from || !draft.to || draft.from > draft.to
  return <div className="cd-period-filter" ref={root}>
    <FilterDropdown label="Período" icon="calendar" value={preset} detail={detail} allowAll={false}
      options={[...COMMERCIAL_PERIODS.map(item => ({ id: item.id, nome: item.label })), { id: 'custom', nome: 'Período personalizado' }]}
      onChange={value => {
        if (value === 'custom') { setDraft(period); setOpen(true) }
        else { setOpen(false); onPreset(value) }
      }} />
    {open && <form className="cd-custom-period" role="dialog" aria-label="Período personalizado" onSubmit={event => {
      event.preventDefault()
      if (!invalid) { onCustom(draft); setOpen(false) }
    }}>
      <strong>Período personalizado</strong>
      <div className="cd-custom-period-dates">
        <label>Data inicial<input ref={firstInput} type="date" className="input" required value={draft.from} max={draft.to || undefined} onChange={event => setDraft(current => ({ ...current, from: event.target.value }))} /></label>
        <label>Data final<input type="date" className="input" required value={draft.to} min={draft.from || undefined} onChange={event => setDraft(current => ({ ...current, to: event.target.value }))} /></label>
      </div>
      {draft.from && draft.to && draft.from > draft.to && <small role="alert">A data final deve ser igual ou posterior à inicial.</small>}
      <footer><button type="button" onClick={() => setOpen(false)}>Cancelar</button><button type="submit" disabled={invalid}>Aplicar</button></footer>
    </form>}
  </div>
}
